import type { GetToePortsQueryVariables } from "gql/graphql";

function filterColumns<T extends { id?: string }>(
  data: T[],
  isInternal: boolean,
  getToePortsVariables: GetToePortsQueryVariables,
): T[] {
  const {
    canGetAttackedAt,
    canGetAttackedBy,
    canGetFirstAttackAt,
    canGetSeenFirstTimeBy,
    canGetBePresentUntil,
  } = getToePortsVariables;

  return data.filter((filter): boolean => {
    switch (filter.id) {
      case "attacked_at":
        return isInternal && canGetAttackedAt;
      case "attacked_by":
        return isInternal && canGetAttackedBy;
      case "first_attack_at":
        return isInternal && canGetFirstAttackAt;
      case "seen_first_time_by":
        return isInternal && canGetSeenFirstTimeBy;
      case "be_present_until":
        return isInternal && canGetBePresentUntil;
      case undefined:
      default:
        return true;
    }
  });
}

export { filterColumns };
